import React, { useState, useEffect } from 'react';
import {
  TableContainer,
  Paper,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Box,
  Autocomplete,
  TextField,
} from '@mui/material';
import TableComponent from './TableComponent';

const PoBookingTable = ({ orderData = [], yearData = [] }) => {
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [filteredData, setFilteredData] = useState(orderData);

  useEffect(() => {
    let filtered = orderData;
    if (selectedYear) {
      filtered = filtered.filter((row) => row.year === selectedYear);
    }
    if (selectedMonth) {
      filtered = filtered.filter((row) => row.month === selectedMonth);
    }
    setFilteredData(filtered);
  }, [selectedYear, selectedMonth, orderData]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        mt: 3,
        p: 2,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: '#ffffff',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          variant='h6'
          sx={{ mb: 2, fontWeight: 'bold' }}
        >
          Order Bookings
        </Typography>

        <Box sx={{ display: 'flex', mb: 3, gap: 10 }}>
          <Autocomplete
            options={yearData}
            value={selectedYear}
            onChange={(event, newValue) => setSelectedYear(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Year'
                sx={{
                  '& .MuiInputBase-root': {
                    height: '46px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                  '& .MuiInputLabel-root': {
                    top: '-4px',
                  },
                }}
              />
            )}
            sx={{
              minWidth: 120,
              '& .MuiAutocomplete-inputRoot': { height: '46px' },
            }}
          />

          <Autocomplete
            options={[
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
            ]}
            value={selectedMonth}
            onChange={(event, newValue) => setSelectedMonth(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Month'
                sx={{
                  '& .MuiInputBase-root': {
                    height: '46px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                }}
              />
            )}
            sx={{
              minWidth: 120,
              '& .MuiAutocomplete-inputRoot': { height: '46px' },
            }}
          />
        </Box>
      </Box>

      <TableComponent
        data={filteredData || []}
        columns={[
          { key: 'order_booking_id', label: 'Order ID' },
          { key: 'user_po_id', label: 'User PO ID' },
          { key: 'date', label: 'Date' },
          { key: 'month', label: 'Month' },
          { key: 'year', label: 'Year' },
          {
            key: 'uom',
            label: 'UOM',
            render: (item) => item?.prefix_uom || item?.suffix_uom,
          },
          { key: 'dispatched_qty', label: 'Dispatched Qty' },
          { key: 'po_qty', label: 'PO Qty' },
        ]}
      />
    </TableContainer>
  );
};

export default PoBookingTable;
